export default Object.freeze({
	All: 'all',
	CostCodes: 'costCodes',
	Groups: 'groups',
	Selected: 'selected',
	Search: 'search',
});
